import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useClientAdminAuth } from "../context/ClientAdminAuthContext";
import logo from "../assets/logo1.png";

export default function ClientAdminLogin() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useClientAdminAuth();
  const [clientId, setClientId] = useState("");
  const [clientPassword, setClientPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) return <Navigate to="/client-admin" replace />;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await login({ clientId: clientId.trim(), clientPassword });
      toast.success("Client admin login successful.");
      navigate("/client-admin", { replace: true });
    } catch (error) {
      const message = error.response?.status === 404
        ? "Client API route not found. Restart the Backend server from the updated Backend folder, then try again."
        : error.response?.data?.message || "Unable to sign in with those client credentials.";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-[#3b0000] via-[#640101] to-[#975607] px-4 py-10">
      <section className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        <div className="mb-7 text-center">
          <img src={logo} alt="Kanchira" className="mx-auto mb-4 h-20 w-20 rounded-2xl object-cover" />
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-700">Kanchira integration</p>
          <h1 className="mt-2 text-2xl font-black text-[#640101]">Client Admin</h1>
          <p className="mt-2 text-sm text-gray-500">Sign in with your assigned client ID and password.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <label className="block text-sm font-medium text-gray-700">
            Client ID
            <input
              autoComplete="username"
              className="kanchira-input mt-1"
              value={clientId}
              onChange={(event) => setClientId(event.target.value)}
              required
            />
          </label>
          <label className="block text-sm font-medium text-gray-700">
            Client Password
            <input
              type="password"
              autoComplete="current-password"
              className="kanchira-input mt-1"
              value={clientPassword}
              onChange={(event) => setClientPassword(event.target.value)}
              required
            />
          </label>
          <button className="btn-primary w-full py-3" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-gray-500">
          This panel is separate from the regular admin accounts.{" "}
          <Link className="font-semibold text-[#640101] hover:underline" to="/login">Admin login</Link>
        </p>
      </section>
    </main>
  );
}
